// Prefixes every key this app (admin portal, "AFE") writes to localStorage/
// sessionStorage, so it can't collide with the tenant portal ("FE") if both
// are ever served from the same origin.
const PREFIX = 'afe_';

export const STORAGE_KEYS = {
  ACCESS_TOKEN: `${PREFIX}accessToken`,
  TOKEN_EXPIRES_AT: `${PREFIX}token_expires_at`,
  PROCESSING_INVITATION: `${PREFIX}processing_invitation`,
  AUTH0_LOGOUT_FORCED: `${PREFIX}auth0_logout_forced`,
} as const;
